// extracted by mini-css-extract-plugin
export default {"carousel-swiper":"c8z3a","carousel-one-slide":"DGk6x","carousel-slide":"a6XVO","many-slides":"WwFSk","carousel-dots":"ZHmGc","group-slide":"iV2OW"};